import type {
  PlatformEvent,
  PlatformEventInput,
} from '@/platform/events/EventModels';
import { platformEventBus } from '@/platform/events/EventBus';

function nowIso(): string {
  return new Date().toISOString();
}

export function publishPlatformEvent(
  eventInput: PlatformEventInput,
): PlatformEvent {
  const event: PlatformEvent = {
    ...eventInput,
    id: eventInput.id ?? crypto.randomUUID(),
    occurredAt: eventInput.occurredAt ?? nowIso(),
  };

  platformEventBus.publish(event);
  return event;
}
